module.exports = __webpack_public_path__ + "static/header-logo-b028bfc943d365a4d0ee36c3e55f3d1f.png";